import {
    LOAD_SCOUTING_DATA,
    SET_SCOUTING_DATA,
    SET_CURRENT_SCOUTING,
    SCOUTING_HOVERED,
    ADDING_NEW_SCOUTING,
    RESET_SCOUTING,
    MOBILE_SHOW_MAP,
    CLICKED_SCOUTING,
} from './constants';

export function loadScoutingData(field_id) {
    return {
        type: LOAD_SCOUTING_DATA,
        field_id: field_id,
    };
}

export function scoutingDataLoaded(data) {
    return {
        type: SET_SCOUTING_DATA,
        data,
    };
}

export function currentScoutingLoaded(data) {
    return {
        type: SET_CURRENT_SCOUTING,
        data,
    };
}

export function resetScouting() {
    return {
        type: RESET_SCOUTING,
    };
}

export function scoutingHovered(data) {
    return {
        type: SCOUTING_HOVERED,
        data,
    };
}
export function setClickedScouting(data) {
    return {
        type: CLICKED_SCOUTING,
        data,
    };
}

export function addingNewScouting(data) {
    return {
        type: ADDING_NEW_SCOUTING,
        data,
    };
}

export function toggleMobileShowMap(data) {
    return {
        type: MOBILE_SHOW_MAP,
        data,
    };
}
